import { auth } from '../api/client';

/**
 * The signed-out interstitial.
 *
 * Logout MUST land here, never on /auth/login: the browser still holds a live
 * oauth.yandex.ru session, so pointing a logout straight at the login hop makes
 * Yandex answer silently and the user is back in the app before they noticed
 * they logged out (production bug on the previous boilerplate — see
 * LLM_CONTEXT/02-auth.md, gotcha #4). This page makes the signed-out state
 * explicit; going back in is a deliberate click on a FULL navigation.
 */
export function LoggedOutPage() {
  return (
    <div className="interstitial">
      <div className="interstitial__card">
        <span className="interstitial__logo" aria-hidden="true">
          iS
        </span>
        <h1>You are signed out</h1>
        <p>Your session was closed. Sign in again when you are ready.</p>
        {/* Full navigation: the OAuth flow is a server-side redirect chain. */}
        <a className="btn btn--primary" href={auth.loginUrl} data-testid="sign-in">
          Sign in with Yandex
        </a>
      </div>
    </div>
  );
}
